<div class="fmnts-radio-button__radio">
  <!-- Render this element first so the input is on top. -->
  <div
    class="fmnts-radio-button__touch-target"
    (click)="_onTouchTargetClick($event)"
  ></div>
  <input
    #input
    class="fmnts-radio-button__native-control"
    type="radio"
    [id]="inputId()"
    [checked]="checked"
    [disabled]="_disabled()"
    [attr.name]="name()"
    [attr.value]="value"
    [required]="_required()"
    [attr.aria-label]="ariaLabel"
    [attr.aria-labelledby]="ariaLabelledby"
    [attr.aria-describedby]="ariaDescribedby"
    (change)="_onInputInteraction($event)"
    [tabindex]="tabindex()"
  />
</div>
<label class="fmnts-radio-button__label" [for]="inputId()">
  <ng-content></ng-content>
</label>
